import { render, staticRenderFns } from "./transferDetails.vue?vue&type=template&id=935e7eb6"
import script from "./transferDetails.vue?vue&type=script&lang=js"
export * from "./transferDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports